import { Component } from '@verndale/core';
import MicroModal from 'micromodal';
import { constEvent } from '../utils/constants';
import { dispatchGenericEvent } from '../utils/dispatch-events';

class Module extends Component {
  setupDefaults() {
    this.id = this.el.id;
    this.dom = {
      $accept: this.el._$('.confirmation-modal__accept'),
      $deny: this.el._$('.confirmation-modal__deny'),
      $close: this.el._$('.confirmation-modal__close')
    }
  }

  addListeners() {
    this.el._on(constEvent.OPEN_CONFIRMATION_MODAL, this.openModal.bind(this));
    this.el._on(constEvent.CLOSE_CONFIRMATION_MODAL, this.closeModal.bind(this));
    this.dom.$accept._on('click', this.accept.bind(this));
    this.dom.$deny._on('click', this.deny.bind(this));
    this.dom.$close._on('click', this.closeModal.bind(this));
  }

  openModal() {
    MicroModal.show(this.id, {
      openClass: 'confirmation-modal--open'
    });
  }

  closeModal() {
    MicroModal.close(this.id);
  }

  accept() {
    dispatchGenericEvent(constEvent.ACCEPT_CONFIRMATION, {}, this.el);
    this.closeModal();
  }

  deny() {
    dispatchGenericEvent(constEvent.DENY_CONFIRMATION, {}, this.el);
    this.closeModal();
  }
}

export default Module;
